import React, { useEffect, useState, useContext } from 'react';
import { MdOutlinePhotoCamera } from 'react-icons/md';
import { FaUserCircle } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { color } from 'styles/pallete';
import useWindowSize from 'hooks/useWindowSize';
import LoadGeneralContext from 'context/LoadGeneralContext';
import { UseTranslationProps } from 'types/UseTranslationProps';

interface PhotoMyAccountProps {
	getImage: any;
	imageProps: any;
}

export default function PhotoMyAccount({
	getImage,
	imageProps
}: PhotoMyAccountProps) {
	const { t }: UseTranslationProps = useTranslation();
	const { width } = useWindowSize();
	const { setIsOpenLoad } = useContext(LoadGeneralContext);

	const [isOpenHoverDiv, setIsOpenHoverDiv] = useState(false);
	const [image, setImage] = useState<any>(imageProps);
	const [errorPhoto, setErrorPhoto] = useState(false);

	async function savePhoto(event: any) {
		if (event.target.files.length > 0) {
			const extesions = ['png', 'jpeg', 'jpg', 'gif'];
			let isPhoto = false;

			extesions.forEach((item) => {
				const isExist = event.target.value.indexOf(item);
				if (isExist !== -1) isPhoto = true;
			});

			if (isPhoto) {
				const file = event.target.files[0];
				setErrorPhoto(false);
				setIsOpenLoad(true);
				const imageFromserver = false; //preciso colocar aqui a função de salvar imagem
				setIsOpenLoad(false);
				setImage({
					file,
					blob: URL.createObjectURL(event.target.files[0]),
					imageFromserver
				});
			} else {
				setErrorPhoto(true);
				setImage('');
			}
		}
	}

	//função que retorna a foto pro pré visualizador de imagens circular
	function returnUrlImage(img: any) {
		if (typeof img === 'string') return img;
		if ('imageFromserver' in img) return img.imageFromserver.ImageUrl;
		return '';
	}

	useEffect(() => {
		getImage(image);
	}, [image]);

	return (
		<>
			<label id="inputMyAccount">
				<S.photo
					$image={returnUrlImage(image)}
					onMouseOver={() => setIsOpenHoverDiv(true)}
					onMouseOut={() => setIsOpenHoverDiv(false)}
				>
					{image === '' && (
						<FaUserCircle
							style={{
								color: color.interface.darkgray2,
								fontSize: '100px',
								cursor: 'pointer',
								position: 'absolute'
							}}
						/>
					)}
					{isOpenHoverDiv && (
						<S.hoverDiv>
							<MdOutlinePhotoCamera />
							<p>{t('myAccount.btnChangePhoto')}</p>
						</S.hoverDiv>
					)}
					<S.inputFile
						draggable="true"
						type="file"
						name="banner"
						id="inputMyAccount"
						accept="image/png, image/jpeg, image/jpg"
						onChange={(event) => savePhoto(event)}
					/>
				</S.photo>
			</label>
			{errorPhoto && (
				<S.errorFile>
					* <p>{t('myAccount.errorPhoto')}</p>
				</S.errorFile>
			)}
			{width! < 1000 && <p>{t('myAccount.messsageMobile')}</p>}
		</>
	);
}
